export default __webpack_public_path__ + "static/media/passport.c95bf952.svg";